/**
    STATIC_BLOCK refers to placeholder blocks in the block layout, once they are added to the canvas they will be called: CUSTOMIZED_BLOCK
*/
export const STATIC_BLOCK = 'STATIC_BLOCK';
export const CUSTOMIZED_BLOCK = 'CUSTOMIZED_BLOCK';
export const CUSTOMIZED_BLOCK_COLUMN = 'CUSTOMIZED_BLOCK_COLUMN';
export const STAFFBASE_POST = 'STAFFBASE_POST';
export const ITEM_SOURCE_CANVAS = 'ITEM_SOURCE_CANVAS';
export const STATIC_BLOCK_COLUMN_ITEM = 'STATIC_BLOCK_COLUMN_ITEM';
export const CUSTOMIZED_BLOCK_COLUMN_ITEM = 'CUSTOMIZED_BLOCK_COLUMN_ITEM';
export const ITEM_SOURCE_COLUMN = 'ITEM_SOURCE_COLUMN';
export const ITEM_SOURCE_ELEMENTS_COLLECTION = 'ITEM_SOURCE_ELEMENTS_COLLECTION';
export const ELEMENT_TYPES = {
    IMAGE: 'IMAGE',
    PARAGRAPH: 'PARAGRAPH',
    BUTTON: 'BUTTON',
    SPACER: 'SPACER',
    SOCIAL: 'SOCIAL',
    SURVEY: 'SURVEY',
    VIDEO: 'VIDEO',
};
export const APPLICATION_MODES = {
    EDITOR: 'EDITOR',
    PREVIEW: 'PREVIEW',
    VERSION_HISTORY: 'VERSION_HISTORY',
} as const;

export const DRAFT_ACCESS = {
    OWNER: 'owner',
    READ: 'read',
    WRITE: 'write',
};
